import React, { useEffect, useState } from 'react';
import styles from './A_SmallInput.module.css';
import cn from 'classnames';

interface A_SmallInputProps {
  label: string;
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  background?: 'white' | 'gray';
  maxLength?: number;
}

export default function A_SmallInput({
  label,
  value,
  onChange,
  placeholder,
  disabled = false,
  background = 'gray',
  maxLength,
}: A_SmallInputProps) {
  const isControlled = value !== undefined;
  const [innerValue, setInnerValue] = useState<string>(label);

  const inputValue = isControlled ? value : innerValue;

  useEffect(() => {
    if (!isControlled) {
      setInnerValue(label);
    }
  }, [isControlled, label]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    if (!isControlled) {
      setInnerValue(newValue);
    }
    onChange?.(newValue);
  };

  return (
    <input
      className={cn(
        styles.wrapper,
        'text-p-7',
        styles[`background-${background}`]
      )}
      value={inputValue}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
      maxLength={maxLength}
    />
  );
}
